module.exports = __webpack_public_path__ + "static/media/frog(13).2429db36.PNG";